import authGuard from "@/router/authGuard";
import CourseDetail from "@/views/V2/courses/CourseDetail.vue";
import CourseIntroduction from "@/views/V2/courses/CourseIntroduction.vue";
import CoursePerformance from "@/views/V2/courses/CoursePerformance.vue";
import CourseLessons from "@/views/V2/courses/CourseLessons.vue";
import CoursePractice from "@/views/V2/courses/CoursePractice.vue";
import CourseSimulacrum from "@/views/V2/courses/CourseSimulacrum.vue";
import CourseExams from "@/views/V2/courses/CourseExams.vue";
import CourseExamDiag from "@/views/V2/courses/CourseExamDiag.vue";
import LessonIntro from "@/views/V2/courses/lessons/LessonIntro.vue";
import LessonDetail from "@/views/V2/courses/lessons/LessonDetail.vue";
import PracticeIntro from "@/views/V2/courses/practices/PracticeIntro.vue";
import PracticeDetail from "@/views/V2/courses/practices/PracticeDetail.vue";
import SimulacrumIntro from "@/views/V2/courses/simulacrums/SimulacrumIntro.vue";
import SimulacrumDetail from "@/views/V2/courses/simulacrums/SimulacrumDetail.vue";
import ExamIntro from "@/views/V2/courses/exams/ExamIntro.vue";
import ExamDetail from "@/views/V2/courses/exams/ExamDetail.vue";
import ExerciseResults from "@/views/V2/courses/ExerciseResults.vue";
import CourseOlympicPhases from "@/views/V2/courses/CourseOlympicPhases.vue";

import ExamDiagIntro from "@/views/V2/courses/examDiag/ExamIntro.vue";
import ExamDiagDetail from "@/views/V2/courses/examDiag/ExamDetail.vue";

export default {
  path: "/course/:id",
  component: CourseDetail,
  name: "CourseDetail",
  redirect: "/course/:id/introduction",
  beforeEnter: authGuard,
  children: [
    {
      path: "/course/:id/introduction",
      component: CourseIntroduction,
      name: "CourseIntroduction",
      meta: {
        title: "Introducción",
      },
    },
    {
      path: "/course/:id/phases",
      component: CourseOlympicPhases,
      name: "CourseOlympicPhases",
      meta: {
        title: "Fases",
      },
    },
    {
      path: "/course/:id/lessons",
      component: CourseLessons,
      name: "CourseLessons",
      redirect: "/course/:id/lessons/intro",
      meta: {
        title: "Lecciones",
      },
      children: [
        {
          path: "/course/:id/lessons/intro",
          component: LessonIntro,
          name: "LessonIntro",
        },
        {
          path: "/course/:id/lessons/:lessonId",
          component: LessonDetail,
          name: "LessonDetail",
        },
      ],
    },
    {
      path: "/course/:id/diagnosticTest",
      component: CourseExamDiag,
      name: "diagnosticTest",
      redirect: "/course/:id/diagnosticTest/intro",
      meta: {
        title: "Lecciones",
      },
      children: [
        {
          path: "/course/:id/diagnosticTest/intro",
          component: ExamDiagIntro,
          name: "ExamDiagIntro",
        },
        {
          path: "/course/:id/diagnosticTest/:examId",
          component: ExamDiagDetail,
          name: "ExamDiagDetail",
        },
        {
          path: "/course/:id/:test/:originId/results",
          component: ExerciseResults,
          name: "results",
        },
      ],
    },
    {
      path: "/course/:id/practices",
      component: CoursePractice,
      name: "CoursePractice",
      redirect: "/course/:id/practices/intro",
      meta: {
        title: "Lecciones",
      },
      children: [
        {
          path: "/course/:id/practices/intro",
          component: PracticeIntro,
          name: "PracticeIntro",
        },
        {
          path: "/course/:id/practices/:practiceId",
          component: PracticeDetail,
          name: "PracticeDetail",
        },
      ],
    },
    {
      path: "/course/:id/simulacrums",
      component: CourseSimulacrum,
      name: "CourseSimulacrum",
      redirect: "/course/:id/simulacrums/intro",
      meta: {
        title: "Simulacros",
      },
      children: [
        {
          path: "/course/:id/simulacrums/intro",
          component: SimulacrumIntro,
          name: "SimulacrumIntro",
        },
        {
          path: "/course/:id/simulacrums/:simulacrumId",
          component: SimulacrumDetail,
          name: "SimulacrumDetail",
        },
        {
          path: "/course/:id/simulacrums/:simulacrumId/review",
          component: SimulacrumDetail,
          name: "SimulacrumDetailReview",
          props: { review: true }
        },
      ],
    },
    {
      path: "/course/:id/exams",
      component: CourseExams,
      name: "CourseExams",
      redirect: "/course/:id/exams/intro",
      meta: {
        title: "Exámenes",
      },
      children: [
        {
          path: "/course/:id/exams/intro",
          component: ExamIntro,
          name: "ExamIntro",
        },
        {
          path: "/course/:id/exams/:examId",
          component: ExamDetail,
          name: "ExamDetail",
        },
        {
          path: "/course/:id/exams/:examId/review",
          component: ExamDetail,
          name: "ExamDetailReview",
          props: { review: true }
        },
      ],
    },
    {
      path: "/course/:id/performance",
      component: CoursePerformance,
      name: "CoursePerformance",
      meta: {
        title: "Tu desempeño",
      },
    }
  ],
};
